import React from 'react';

import { flagStyles } from '../settings';

const SvgMC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3264px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMC;
